import { render, staticRenderFns } from "./ListReceipt.vue?vue&type=template&id=6233cc6e&scoped=true&"
import script from "./ListReceipt.vue?vue&type=script&lang=ts&"
export * from "./ListReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./ListReceipt.vue?vue&type=style&index=0&id=6233cc6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6233cc6e",
  null
  
)

export default component.exports